import { File } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FileIcon = createLucideIcon(File);
